import styled from 'styled-components';

import { pxToRem } from '../../utils/pxToRem';
import { palette } from '../../theme/palette';

export const SavingGoal = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
